import React from "react";
import { Typography, Button, Row, Col, Form, message, Modal } from "antd";
import InputBox from "../../../components/common/input";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";
import axios from "axios";
const { Title, Text } = Typography;

const ChangePasswordModal = ({ open, onClose, onConfirm }) => {

  const [form] = Form.useForm();
  // const { forgetData } = useSelector((state) => state.auth);
  const forgetData =  localStorage.getItem("ACCESS_TOKEN")
  const navigate = useNavigate()

 
  const handleResetPassword = async (values) => {

    // const new_password = {old-password: values?.newPassword

      const data = {
        old_password: values?.old_password,
        new_password: values?.newPassword,
      }



    const headers = {
      Authorization: `Bearer ${forgetData}`, // Ensure forgetData contains a valid token
      "Content-Type": "application/json",
      "x-api-key": process.env.REACT_APP_API_KEY,
    };

    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_API_URI}/admin/auth/password/change`, // Ensure the correct base URL
        { ...data },  // Request body
        { headers } // Headers
      );
  
    
  
      if (response?.status === 201 || 200) {
        // navigate('/')
        toast.success('Password Change Successfully')
        form.resetFields();
        onClose()
      } else {
        message.error(response?.data?.message || "reset password verification failed");
      }
    } catch (error) {
     
      console.error("Error verifying OTP:", error);
      
    }
  };



  
  return (
    <Modal
      centered
      open={open}
      onCancel={onClose}
      footer={[
        <Button
          key="confirm"
          // onClick={onConfirm}
          type="primary"
          className="confirm-btn"
          onClick={() => form.submit()}
        >
          {"Change Password"}
        </Button>,
      ]}
      className="custom-confirm-modal"
    >
      <div className="changePassword">
        <Row gutter={16} className="signin-row">
          <Col xs={24} sm={24}>
            <div className="cflex">
              <div className="leftContainer">
                <Title level={2}>Change Password</Title>
                <Text className="subtitle mb-2">
                  Almost done. Enter your new password and you’re all set.
                </Text>
                <Form
                form={form}
                layout="vertical"
                 requiredMark="optional"
                onFinish={handleResetPassword}
                className="signin-form"
              >
                {/* New Password */}
                <Form.Item
                style={{ marginBottom: "15px" }}
                label={<span>New Password<span style={{ color: "red" }}>*</span></span>}
                  name="old_password"
                  
                  rules={[
                    { required: true, message: "Please enter old password!" },
                  ]}
                  hasFeedback
                >
                  <InputBox
                    size="large"
                    placeholder="Old Password"
                    className="custom-input"
                    type="password"
                  />
                </Form.Item>
                <Form.Item
                style={{ marginBottom: "15px" }}
                label={<span>New Password<span style={{ color: "red" }}>*</span></span>}
                  name="newPassword"
                  
                  rules={[
                    { required: true, message: "Please enter a new password!" },
                  ]}
                  hasFeedback
                >
                  <InputBox
                    size="large"
                    placeholder="New Password"
                    className="custom-input"
                    type="password"
                  />
                </Form.Item>

                {/* Confirm New Password */}
                <Form.Item
                style={{ marginBottom: "15px" }}
                  name="confirmPassword"
                  label={<span>Confirm New Password<span style={{ color: "red" }}>*</span></span>}
                  dependencies={["newPassword"]}
                  rules={[
                    { required: true, message: "Please confirm your new password!" },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue("newPassword") === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error("Passwords do not match!"));
                      },
                    }),
                  ]}
                  hasFeedback
                >
                  <InputBox
                    size="large"
                    placeholder="Confirm New Password"
                    className="custom-input"
                    type="password"
                  />
                </Form.Item>
                </Form>
               
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </Modal>
  );
};

export default ChangePasswordModal;
